import { types as t, getRoot } from 'mobx-state-tree';

import { User } from 'models/users';

export const UserRef = t.maybe(
  t.reference(User, {
    get(identifier, parent) {
      const root = getRoot(parent);

      if (root.users?.items.has(identifier)) {
        return root.users.items.get(identifier);
      }

      if (root.env.userStore?.items.has(identifier)) {
        return root.env.userStore.items.get(identifier);
      }

      return User.create({
        id: identifier,
        name: root.env.t('user.unknown'),
        isActive: true,
      });
    },
    set(value) {
      return value.id;
    },
  })
);
